import { render, staticRenderFns } from "./PopoverGroup.vue?vue&type=template&id=f3451ce8&"
import script from "./PopoverGroup.vue?vue&type=script&lang=js&"
export * from "./PopoverGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports